import { cent2dollar } from '@hk01-digital/wallet-internal-sdk'

export const formatNumerics = (numerics) => {
  try {
    return `${numerics.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}`
  } catch (exception) {
    console.error('Format Numerics Fail.')
    return ''
  }
}

export const formatCashNumber = (cash) => {
  return `HK$ ${cent2dollar(cash)}`
}
